import { render, staticRenderFns } from "./mailrecord-add-or-update.vue?vue&type=template&id=b8fa6bb6&"
import script from "./mailrecord-add-or-update.vue?vue&type=script&lang=js&"
export * from "./mailrecord-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports